import React, {useCallback, useContext, useEffect, useRef, useState} from "react";
import {Alert, Button, Form, Radio, Spin, Tooltip} from "antd";
import Seperator from "./Seperator";
import CheckboxGroupWithJointCheckAll from "./CheckboxGroupWithJointCheckAll";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";
import useInputs from "../../../utils/hooks/useInputs";
import "./WidgetSearchByUid.scss";
import MapPropsContext from "../MapPropsContext";
import {getPointByMtr} from "../../../api";



const WidgetPublicStatStationInputBox = ( {} ) => {
  // const [newmtrCodeValue, setNewmtrCodeValue] = useState();
  const [message, setMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const {
    setMapCenter,
    setClickedPointIconObjects,
  } = useContext(MapPropsContext);

  const {
    widgetState,
    onChangeWidgetState
  } = useContext(MapPropsContext);
  const {field1, field2, field3, field4} = widgetState;

  
  const [inputsState, onChange] = useInputs(
    { 
      field1: '', field1Value: '',
      field2: '', field2Value: '',
      field3: '', field3Value: '',
      field4: '', field4Value: '',
    }
  );  

  const onPaste = (e) => {
    const text = (e.clipboardData  || window.clipboardData)
      .getData('text')
      .replace(/[^\d]+/g, '');
      onChange({ 
        target: { 
          //name: 'field1', value: text.slice(0, 5)}
          name: 'field1', value: text.slice(0, 100),
          name: 'field2', value: text.slice(0, 100),
          name: 'field3', value: text.slice(0, 100),
          name: 'field4', value: text.slice(0, 100),
        }
      });
  };

  const moveToStation = useCallback(() => {
    // 초기화
    setClickedPointIconObjects([]);
    setMessage(null);
    setIsLoading(true);

  }, [field1, field2, field3, field4, inputsState]);

  const onClick = () => {
    //console.log(this.field1);
    // alert({field1});
    // console.log({field1});
  }

  return (
    <Form.Item>
      <span><h3>기관</h3></span>
      <span className={"ant-input-affix-wrapper"}>
      <Tooltip title={"기관를 입력해주세요."} placement={"bottom"}>
        <div className={["uid-field", "ant-input"].join(" ")}>
          <input type="text"
              name="field2"
              maxLength={100}
              size={100}
              value={field2}
              onChange={onChangeWidgetState}
              onPaste={onPaste}
              style={{ border: 0, width: '16.8em' }} />
        </div>
      </Tooltip>
      </span>
      
      <span><h3>주무부처</h3></span>
      <span className={"ant-input-affix-wrapper"}>
      <Tooltip title={"주무부처를 입력해주세요."} placement={"bottom"}>
        <div className={["uid-field", "ant-input"].join(" ")}>
          <input type="text"
              name="field3"
              maxLength={100}
              size={100}
              value={field3}
              onChange={onChangeWidgetState}
              onPaste={onPaste}
              style={{ border: 0, width: '16.8em' }} />
        </div>
      </Tooltip>
      </span>
      
      <span><h3>기관분류</h3></span>
      <span className={"ant-input-affix-wrapper"}>
      <Tooltip title={"기관분류를 입력해주세요."} placement={"bottom"}>
        <div className={["uid-field", "ant-input"].join(" ")}>
          <input type="text"
              name="field1"
              maxLength={100}
              size={100}
              value={field1}
              onChange={onChangeWidgetState}
              onPaste={onPaste}
              style={{ border: 0, width: '16.8em' }} />
        </div>
      </Tooltip>
      </span>

      <span><h3>용도명</h3></span>
      <span className={"ant-input-affix-wrapper"}>
      <Tooltip title={"주무부처를 입력해주세요."} placement={"bottom"}>
        <div className={["uid-field", "ant-input"].join(" ")}>
          <input type="text"
              name="field4"
              maxLength={100}
              size={100}
              value={field4}
              onChange={onChangeWidgetState}
              onPaste={onPaste}
              style={{ border: 0, width: '16.8em' }} />
        </div>
      </Tooltip>
      </span>
      
       
      {/* 
      <Button type={"primary"}
              disabled={!/^\d{5}/g.test(field1) || isLoading}
              onClick={onClick}
              style={{ width: '100%' }}>
        {isLoading && <Spin />}
        {!isLoading && "검색하기"}
      </Button> 
      */}
      
    </Form.Item>
  );
}

export default WidgetPublicStatStationInputBox;